type Mount = (props: Record<string, unknown>) => void;
type Unmount = () => void;

const registeredApps: Record<string, Record<string, { mount: Mount; unmount: Unmount }>> = {};

export const register = (domain: string, name: string, mount: Mount, unmount: Unmount) => {
  if (!registeredApps[domain]) {
    registeredApps[domain] = {};
  }

  registeredApps[domain][name] = {
    mount,
    unmount,
  };
};

export const isRegistered = (domain: string, name: string) => {
  return !!(registeredApps[domain] && registeredApps[domain][name]);
};

export const mount = (domain: string, name: string, props: Record<string, unknown>) => {
  if (!isRegistered(domain, name)) {
    throw new Error(`Trying to mount an unexisting app ${domain} - ${name}`);
  }

  registeredApps[domain][name].mount(props);
};

export const unmount = (domain: string, name: string) => {
  if (!isRegistered(domain, name)) {
    return;
  }

  registeredApps[domain][name].unmount();
};
